import { useLocation } from 'react-router-dom';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
}

export default function SEOHead({ title, description, keywords, canonicalUrl, ogType = 'website' }: SEOHeadProps) {
  const location = useLocation();
  const baseUrl = 'https://www.90yingshi.com';
  const pageUrl = canonicalUrl || `${baseUrl}${location.pathname}`;

  const seoTitle = title
    ? `${title} | 90影视 - 免费在线观看高清影视`
    : '90影视 | 免费在线观看不缓冲全集 | 电影电视剧综艺动漫高清无广告';

  const seoDescription = description || '90影视免费在线观看平台，电影电视剧综艺动漫全集不缓冲无广告，高清画质流畅播放，最新热剧每日更新，省钱追剧首选90影视。';
  const seoKeywords = keywords || '90影视,免费,在线观看,不缓冲,全集,无广告,电影,电视剧,高清,综艺,动漫,最新';

  return (
    <>
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      <link rel="canonical" href={pageUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:site_name" content="90影视" />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
    </>
  );
}